// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UpcomingBooking-bookingCardListContainer-KN_HW {
    display: grid;
    gap: 18px;
    grid-gap: 18px;
}

.UpcomingBooking-bookingLoaderContainer-SBYeL {
    padding: 75px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/UpcomingBooking/UpcomingBooking.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".bookingCardListContainer {\n    display: grid;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.bookingLoaderContainer {\n    padding: 75px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bookingCardListContainer": `UpcomingBooking-bookingCardListContainer-KN_HW`,
	"bookingLoaderContainer": `UpcomingBooking-bookingLoaderContainer-SBYeL`
};
module.exports = ___CSS_LOADER_EXPORT___;
